import { Component } from 'react'
import types from '~/types'
import styles from '~/styles/dropdownMenu.module.css'

type props = {
	title: string,
	titleOnly: boolean,
	children: JSX.Element[] | JSX.Element,
}

type state = {}

export default class DropdownMenu extends Component<props, state> {
	constructor(props: props) {
		super(props)
	}
	
	render(): JSX.Element {
		let titleFrameClass = styles.button
		if (this.props?.titleOnly) {
			titleFrameClass += ' ' + styles.grey
		}
		let optionFrameClass = styles.optionsFrame
		if (this.props.isOuterClicked) {
			optionFrameClass += ' ' + styles.hidden
		}
		return (
			<div className={styles.main}>
				<div
					className={titleFrameClass}
					onClick={this._onClick.bind(this)}
				>
					<div className={styles.title}>
						{this.props?.title || ""}
					</div>
					{this._downArrow()}
				</div>
				<div
					className={optionFrameClass}
					onClick={this._hide.bind(this)}
				>
					<div className={styles.options}>
						{this.props.children}
					</div>
				</div>
			</div>
		)
	}
	
	private _downArrow(): JSX.Element | null {
		if (!this.props?.titleOnly) {
			return (
				<>
					<div className={styles.separator} />
					<div className={styles.svgFrame}>
						<svg
							height="20"
							width="20"
							viewBox="0 0 20 20"
							aria-hidden="true"
							focusable="false"
						>
							<path d={this._svgPath()} />
						</svg>
					</div>
				</>
			)
		} else {
			return null
		}
	}
	
	private _onClick(): void {
		this.props.setClickedComponent(this.props.isOuterClicked ? Date.now() : 0)
	}
	
	private _hide(): void {
		this.props.setClickedComponent((this.props.title + ''))
	}
	
	private _svgPath(): string {
		const d = `
			M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747
			3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197
			0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787
			0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z
		`
		return d.replace(/[\t\n]+/g, ' ').trim()
	}
}